module.exports = __webpack_public_path__ + "static/media/patient-list-icon.1117a2ba.svg";